import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import { useControlledComponent, usePrevious } from "../../hooks";
export function useLazyLoad(_ref) {
  var _ref$lazyLoad = _ref.lazyLoad,
      lazyLoad = _ref$lazyLoad === void 0 ? true : _ref$lazyLoad,
      itemCount = _ref.itemCount,
      currentPage = _ref.currentPage,
      loadedProp = _ref.loaded,
      onRequestChange = _ref.onRequestChange;

  var _useState = useState(function () {
    return new Set([currentPage]);
  }),
      _useState2 = _slicedToArray(_useState, 1),
      defaultSet = _useState2[0];

  var _useControlledCompone = useControlledComponent(loadedProp, onRequestChange, defaultSet),
      _useControlledCompone2 = _slicedToArray(_useControlledCompone, 2),
      loaded = _useControlledCompone2[0],
      setLoaded = _useControlledCompone2[1];

  var maxIndex = itemCount - 1;
  var prevIndex = usePrevious(currentPage);
  /**
   * Lazy load panel content
   */

  useEffect(function () {
    function isValidNextIndex(index) {
      return index > 0 && index <= maxIndex;
    }

    function addIndexToLoaded(index) {
      if (!isValidNextIndex(index)) {
        return;
      }

      var indexes = index;
      var indexesArray = Array.isArray(indexes) ? indexes : [indexes];
      var next = new Set(loaded);
      indexesArray.forEach(function (i) {
        // don't set items which are already loaded or are invalid
        if (loaded.has(i) || !isValidNextIndex(index)) {
          return;
        }

        next.add(i);
      });
      setLoaded(next);
    }

    if (lazyLoad && prevIndex !== currentPage) {
      addIndexToLoaded(currentPage);
    }
  }, [prevIndex, currentPage, loaded, maxIndex, lazyLoad, setLoaded]);
  return {
    loaded: loaded,
    shouldLoadIndex: function shouldLoadIndex(i) {
      return !lazyLoad || currentPage === i || loaded.has(i);
    }
  };
}